import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getTicketDetails, ticketReadUnread } from "../../API/api";
import Layout from "../../NewComponent/LayoutEmail/Layout";
import { Card, Divider, Tag, Spin, Modal } from "antd";
import moment from "moment";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
import { replaceContentEditableText } from "../../utils";

export default function TicketDetails() {
  const [data, setData] = React.useState([]);
  const [isLoading, setLoading] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const { ticketId } = useParams();
  const navigate = useNavigate();
  const containerTableStyles = {
    width: "100%",
    margin: "auto",
    marginBottom: "7%",
    border: "1px solid #EAECF0",
    boxShadow: "0px 4px 16px 0px #1018280F",
    borderRadius: "12px",
    minHeight: "450px",
    padding: "24px",
  };
  const containerStyles = {
    width: "90%",
    margin: "auto",
    // marginTop: "1%",
    marginBottom: "7%",
    // padding: "24px",
  };

  const headigStyles = {
    fontSize: "20px",
    lineHeight: "32px",
    color: "#5C667B",
  };
  const headigStyles2 = {
    fontSize: "16px",
    lineHeight: "26px",
    color: "#5C667B",
  };
  const headigStyles3 = {
    fontSize: "14px",
    lineHeight: "26px",
    color: "#5C667B",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontWeight: "300",
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    setLoading(true);
    getTicketDetails(ticketId)
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        ticketReadUnread(ticketId).then((res) => {
          console.log("Tickets updated successfully:", res);
          // Optionally, you can refresh the ticket data after updating
        });
      })
      .catch((err) => {
        console.error("Error fetching ticket details:", err);
      });
  }, [ticketId]);
  return (
    <>
      <Layout>
        <div style={containerStyles}>
          <div className="emailBack" onClick={() => navigate(-1)}>
            <i className="fa fa-arrow-left"></i>&nbsp;Back
          </div>
          <div style={containerTableStyles}>
            <div style={{ textAlign: "center" }}>
              <span style={headigStyles}>Ticket Details</span>
            </div>
            <div className="mt-2">
              <Spin spinning={isLoading}>
                <Card style={{ padding: "10px" }}>
                  <div>
                    <span style={headigStyles}>
                      {data.ticketId}-{data.ticketSubject}
                    </span>
                  </div>
                  <Divider style={{ marginBlock: "10px" }} />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        // border: "1px solid #EAECF0",
                        width: "50%",
                        // padding: "10px",
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "40%", fontWeight: "400" }}>
                          <div style={headigStyles2}>Email Category&nbsp;</div>
                          <div style={headigStyles2}>Requester&nbsp;</div>
                          <div style={headigStyles2}>Assigned to&nbsp;</div>
                        </div>
                        <div style={{ fontWeight: "300" }}>
                          <div style={headigStyles2}>
                            {data.ticketCategory === undefined
                              ? "(Un-assigned)"
                              : data.ticketCategory}{" "}
                          </div>
                          <div style={headigStyles2}>
                            {data.emailFrom !== undefined &&
                              data.emailFrom.split("<")[0]}{" "}
                          </div>
                          <div style={headigStyles2}>
                            {data.expertFirstName !== null &&
                            data.expertFirstName !== undefined
                              ? data.expertFirstName + " " + data.expertLastName
                              : " "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        // border: "1px solid #EAECF0",
                        width: "50%",
                        // padding: "10px",
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "40%", fontWeight: "400" }}>
                          <div style={headigStyles2}>Status&nbsp;</div>
                          <div style={headigStyles2}>Created Date&nbsp;</div>
                          <div style={headigStyles2}>Followers&nbsp;</div>
                        </div>
                        <div style={{ fontWeight: "300" }}>
                          <div style={headigStyles2}>
                            {data.ticketStatus === "Open" && (
                              <Tag color={"#428bca"}>Open</Tag>
                            )}
                            {data.ticketStatus === "Closed" && (
                              <Tag color={"#5d995d"}>Closed</Tag>
                            )}
                          </div>
                          <div style={headigStyles2}>
                            {moment(data.createdDate).format(
                              "MMM DD, YYYY HH:mm:ss A"
                            )}
                          </div>
                          <div style={headigStyles2}>
                            <TooltipComp
                              title={() => {
                                return (
                                  <div>
                                    {data?.ticketCc
                                      ?.split(",")
                                      .map((email, index) => (
                                        <div key={index}>{email.trim()}</div>
                                      ))}
                                  </div>
                                );
                              }}
                            >
                              {
                                data?.ticketCc
                                  ?.split(",")
                                  .map((s) => s.trim())
                                  .filter((s) => s !== "").length
                              }{" "}
                              Followers
                            </TooltipComp>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </Spin>
            </div>
            <br />
            <div>
              {data?.emailEntry?.length > 0 &&
                data.emailEntry.map((email, index) => {
                  return (
                    <div
                      style={{
                        marginBottom: "10px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      key={index}
                    >
                      <div style={{ minWidth: "10%", marginTop: "10px" }}>
                        <span style={headigStyles2}>
                          {index === 0 ? (
                            <span style={{ fontWeight: "400" }}>Original Request</span>
                          ) : (
                            <span style={{ fontWeight: "400" }}>Message {index + 1}</span>
                          )}
                        </span>
                      </div>
                      <div style={{ width: "85%", marginTop: "10px" }}>
                        {email.emailFrom !== null && (
                          <Card style={{ padding: "10px" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  color: "#5C667B",
                                  lineHeight: "22px",
                                  fontSize: "15px",
                                  fontWeight: "500",
                                }}
                              >
                                From&nbsp;<span style={{fontWeight:'500',color:`${email.expertReply===null?"#1491d1":"#ff5400"}`}}>{email.emailFrom}{email.expertReply !== null && <span>&nbsp;(Expert)</span>}</span>&nbsp;
                                <TooltipComp
                                  title={() => {
                                    return (
                                      <div>
                                        <div>To&nbsp; {email.emailTo}</div>
                                        <div>
                                          Date&nbsp;{" "}
                                          {moment(email.emailDate).format(
                                            "MMM DD, YYYY HH:mm:ss A"
                                          )}
                                        </div>
                                      </div>
                                    );
                                  }}
                                >
                                  <i
                                    style={{
                                      fontSize: "17px",
                                      color: "#5c667b",
                                    }}
                                    className="fa fa-caret-down"
                                  ></i>
                                </TooltipComp>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  color: "#5C667B",
                                  lineHeight: "22px",
                                  fontSize: "15px",
                                  fontWeight: "500",
                                }}
                              >
                                Received&nbsp;
                                <span style={{fontWeight:'300'}}>{moment(email.emailDate).format(
                                  "MMM DD, YYYY HH:mm:ss A"
                                )}</span>
                              </div>
                            </div>
                            <Divider style={{ marginBlock: "10px" }} />
                            <div
                              style={headigStyles3}
                              dangerouslySetInnerHTML={{
                                __html: replaceContentEditableText(
                                  email?.emailBody===null
                                    ? email.expertReply
                                    : email.emailBody
                                ),
                              }}
                            ></div>
                          </Card>
                        )}
                        {email.emailFrom === null && (
                          <div
                            style={{
                              border: "1px solid #EAECF0",
                              padding: "15px",
                              display: "flex",
                              borderRadius: "6px",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: "16px",
                              color: "#5C667B",
                              lineHeight: "22px",
                              fontWeight:'300',
                              background:'#fff'
                            }}
                          >
                            <i
                              className="fa fa-paper-plane"
                              style={{ fontSize: "20px", color: "#5C667B" }}
                            ></i>
                            &nbsp;Expert Responses are communicated with the
                            Seeker on {moment(email.emailDate).format("MMM DD")}
                            &nbsp;&nbsp;
                            <span
                              style={{ color: "#428bca", cursor: "pointer", textDecoration: "underline", fontWeight:'500'}} onClick={()=>setIsModalOpen(true)}
                            >
                              Preview
                            </span>
                            <Modal
                                    title=""
                                    closable={{ 'aria-label': 'Custom Close Button' }}
                                    open={isModalOpen}
                                    onCancel={handleCancel}
                                    footer={[]}
                                  >
                                    <div style={headigStyles3} dangerouslySetInnerHTML={{__html: replaceContentEditableText(email.emailBody)}}></div>
                                  </Modal>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
